<template>
  <div>
    <h1>Unable To Find </h1>
  </div>
</template>

<script>
export default {
  name: "404ErrorPage"
}
</script>

<style scoped>

</style>